import classnames from 'classnames';
import { useEffect, useState } from 'react';

import styles from './ErrorMessage.module.scss';
import { ErrorMessageProps } from './ErrorMessage.types';

export const ErrorMessage = ({ error }: ErrorMessageProps) => {
  // Message is memoized for animations
  const [errorMessage, setErrorMessage] = useState(error?.message);

  useEffect(() => {
    if (error?.message) setErrorMessage(error.message);
  }, [error?.message]);

  return (
    <div className={classnames(styles.container, { [styles.expand]: error !== undefined })}>
      <div className={styles.error}>
        <div className={styles.errorMessage}>{errorMessage}</div>
      </div>
    </div>
  );
};
